import { type PayoutState } from 'tradera/apps/my-tradera/app/state/payout/types';

export default (): PayoutState => {
    return {
        isFetching: false,
    };
};
